<template>
<div class="container col-xl-10 col-xxl-8 px-4">
    <div class="row align-items-top g-lg-5 py-5">
      <div class="col-lg-7 text-center text-lg-start">
        <h3 class="fw-bold lh-1 mb-3">Delete Account</h3>
        <p class="col-lg-10 fs-5">If you delete your account now, you have the option to recover it within 30 days via the Hunter &amp; Gold App.</p>
      </div>
       <div class="mx-auto col-lg-5">
        <form class="p-4 p-md-2 border rounded-3 bg-light" @submit="onSubmit">       
          <p class="text-muted p-md-2 h6">To proceed, we need to verify who you are. Please enter your registered email address and we will send you a verification code.</p>  
          <div class="form-floating mb-3">
            <input :disabled='isDisabled' type="email" class="form-control" id="email" placeholder="name@example.com"   @focus="resetValidationMessage()" v-model="email" required >
            <label for="floatingInput">Email address</label>
             <p class="text-danger p-md-2">{{ validationMessage }}</p>             
          </div>

           <button class="w-100 btn btn-lg btn-primary fs-6" type="submit" :disabled='isDisabled'>
            <font-awesome-icon icon="shield-halved" /> <template v-if="!loadingCodeSent">Send</template><template v-else>Sending</template> Verification Code
            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" v-if="loadingCodeSent"></span>
          </button>
         
          <p class="text-primary pt-2 p-md-2">{{ checkAcctMessage }}</p>
          <div v-show="checkComplete">    
             <p class="text-muted p-md-2 h6">Please enter the verification code.</p>  
            <CodeEntry @verifyEvent="verifyAccount"/> 
           
           
            <button class="btn btn-dark btn-sm" :disabled="disableResend" @click="onResend">
            <span style="font-size:smaller;"> <template v-if="disableResend"><font-awesome-icon icon="hourglass-half" /> Resend Code in <Timer @timerEvent="countdownComplete" ref="childref"/> secs</template><template v-else><font-awesome-icon icon="rotate-right" /> Resend code</template></span>
           </button>

          <div class="d-flex flex-column p-2 align-items-center justify-content-center" v-if="loading">
            <div class="row">
              <div class="spinner-border" role="status">
              <span class="sr-only">Verifying...</span>
              </div>
            </div>
            <div class="row">
              <strong>Verifying... Please Wait</strong>
            </div>
          </div>
            <p class="text-primary pt-2 p-md-2">{{ verifyAcctMessage }}</p>
            <p class="text-primary pt-2 p-md-2">{{ getAcctMessage }}</p>
         </div>       
        </form> 
      </div>
    </div>
  </div>
</template>
<script>
import AccountService from "../services/account.service";
import CodeEntry from './CodeEntry';
import Timer from './Timer';
import { nextTick } from 'vue'


export default {
  name: 'Verify',
  
  components: {
   CodeEntry,
   Timer
  },

  setup(props, { emit }) {
    
    const handleOnComplete = (user) => {
      emit("userEvent", user);
    };

    return { handleOnComplete };
  },

  mounted() {
    localStorage.removeItem("token");
  },

  data() {
    return {
      loadingCodeSent: false,
      loading: false,
      email: '',
      validationMessage: '',
      checkAcctMessage: '',
      verifyAcctMessage: '',
      getAcctMessage: '',
      checkComplete: false,
      isDisabled: false,
      disableResend: true,
      user: null
    }
  },
  methods: {
    
    onResend(event) {
      this.disableResend = !this.disableResend;
      event.preventDefault();
      // Makes sure that the element has rendered once disableResend state updated
      nextTick(() => {
        this.startCountDownAndValidate(); 
     })   
    },

    onSubmit(event) {
     event.preventDefault();
     this.startCountDownAndValidate(); 
    },

    startCountDownAndValidate(){
      this.$refs.childref.countDownTimer();
       const isValid = this.validateEmail(this.email)
      if (isValid) {
        this.loadingCodeSent = true;
        this.validationMessage = '';
        this.checkAccount();
      } else {
        this.validationMessage = 'The email is invalid, please correct.';
       }
    },
    
    validateEmail(email) {
      if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email)) {
        return true;
      } else {
      return false;
      }
    },
    resetValidationMessage(){
        this.validationMessage = '';
    },

    countdownComplete(isComplete) {
     this.disableResend = !isComplete;
    },  
    
    checkAccount() {
      this.checkAcctMessage = "";
      AccountService.check(this.email).then(
        (response) => {
          this.loadingCodeSent = false;
          this.checkAcctMessage = "";
          this.checkComplete = false;
          this.chkAcctMessage = "Please enter the code sent to your email address.";
          this.checkComplete = true;
          this.isDisabled = true;
        },
        (error) => {
          this.loadingCodeSent = false;
          this.checkComplete = false;
          this.isDisabled = false;

          this.checkAcctMessage =
            (error.response &&
              error.response &&
              error.response.data.detail) ||
            error.response.data.detail ||
            error.response.data.detail.toString();
        }
      );
    },

     verifyAccount(code) {
      this.loading = true;
      this.verifyAcctMessage = "";

      AccountService.verify(code, this.email).then(
        (response) => {
          this.verifyAcctMessage = "";
          let token = response.data.access_token;

          if (localStorage.getItem("token") != null)
            localStorage.removeItem("token")

          localStorage.setItem("token", token);
          
          AccountService.get().then(
            (response) => {     
              this.getAcctMessage = "";
              this.loading = false;
              this.handleOnComplete(response);  
            },
            (error) => {
              this.loading = false;
              this.getAcctMessage  =
                (error.response &&
                  error.response &&
                  error.response.data.detail) ||
                error.response.data.detail ||
                error.response.data.detail.toString();
        
            }
          );
        },
        (error) => {
          this.loading = false;
          this.verifyAcctMessage  =
            (error.response &&
              error.response &&
              error.response.data.detail) ||
            error.response.data.detail ||
            error.response.data.detail.toString();
        }
      );
    }
  }
}
</script>
<style scoped>

.btn-primary, .btn-primary:hover, .btn-primary:active, .btn-primary:visited {
    background-color: #276FB7 !important;
}

.otp-input {
  width: 40px;
  height: 40px;
  padding: 5px;
  margin: 0 10px;
  font-size: 20px;
  border-radius: 4px;
  border: 1px solid rgba(0, 0, 0, 0.3);
  text-align: center;
}
/* Background colour of an input field with value */
.otp-input.is-complete {
  background-color: #e4e4e4;
}
.otp-input::-webkit-inner-spin-button,
.otp-input::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
input::placeholder {
  font-size: 15px;
  text-align: center;
  font-weight: 600;
}
</style>
